export enum EIntervalTypes {
    EVERY_MINUTE = 'every_minute',
    EVERY_HOUR = 'every_hour',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly'
}
  